<img *ngIf="blobUrl" [attr.src]="blobUrl" height="100%" width="100%" />
<div *ngIf="!blobUrl">loading..</div>
